// important styles (global & accounts page)
import "./index.css";

// pages
// import "./pages/accounts/accounts.js";
// import "./pages/payments/payments.js";
// lazy load soundboard
import ( /*webpackChunkName: "soundboard"*/ "./pages/soundboard/soundboard.js");

// import './pages/support/support.js';

// // lazy load fork
// import ( /*webpackChunkName: "fork"*/ "./components/fork/fork.js");
